import {
    FaBatteryFull,
    FaBolt,
    FaExclamationTriangle,
    FaCheckCircle,
    FaHourglassHalf,
    FaQuestionCircle
} from "react-icons/fa";

import "./RobotStatusUI.css";

// Shared between RobotFleet.js, RobotDetail.js, and Dashboard.js's
// real-time status widget - extracted here so all three render a
// robot's status/battery/command-outcome identically, rather than
// three separate copies drifting apart over time.

export function batteryClass(pct) {

    if (pct === null || pct === undefined) {
        return "mid";
    }

    if (pct <= 20) {
        return "low";
    }

    if (pct <= 50) {
        return "mid";
    }

    return "ok";

}

// Outcome is computed server-side by comparing what the robot's own
// telemetry actually did after this command was sent - see
// robot_service.compute_command_outcome. A "sent" status only means
// Orion's cloud accepted the command; this is what actually tells you
// whether the robot responded.
export function OutcomeBadge({ outcome }) {

    if (!outcome || outcome === "not_applicable") {
        return null;
    }

    const config = {

        confirmed: { icon: <FaCheckCircle />, label: "Robot responded", cls: "confirmed" },

        pending: { icon: <FaHourglassHalf />, label: "Waiting to confirm...", cls: "pending" },

        no_response: { icon: <FaQuestionCircle />, label: "No response from robot", cls: "no-response" }

    }[outcome];

    if (!config) {
        return null;
    }

    return (

        <span className={`outcome-badge ${config.cls}`} title="Based on the robot's own telemetry after this command, not just whether Orion accepted it">
            {config.icon} {config.label}
        </span>

    );

}

export function StatusPill({ robot }) {

    if (robot.is_emergency_stop) {

        return (
            <span className="pill pill-emergency">
                <FaExclamationTriangle /> Emergency Stop
            </span>
        );

    }

    if (!robot.online) {

        return <span className="pill pill-offline">Offline</span>;

    }

    if (robot.is_charging) {

        return (
            <span className="pill pill-charging">
                <FaBolt /> Charging
            </span>
        );

    }

    if (robot.low_battery) {

        return (
            <span className="pill pill-low-battery">
                <FaExclamationTriangle /> Low Battery
            </span>
        );

    }

    if (robot.is_idle) {

        return <span className="pill pill-idle">Idle</span>;

    }

    // Online and none of the above - reflects fleet status only
    // (online/offline/idle/charging/low battery), not the robot's raw
    // current task. task_label can be an unmapped/undecoded internal
    // task key (observed directly: a raw Android package identifier
    // showing up here) when the backend has no human-readable label
    // for it - showing that to an admin is confusing and not
    // meaningful fleet-status information, so it's not used here.
    return <span className="pill pill-online">Online</span>;

}

export function BatteryBar({ pct }) {

    const cls = batteryClass(pct);

    return (

        <div className="battery-cell">

            <FaBatteryFull style={{ color: cls === "low" ? "#ef4444" : cls === "mid" ? "#f59e0b" : "#22c55e" }} />

            <div className="battery-track">
                <div
                    className={`battery-fill ${cls}`}
                    style={{ width: `${pct ?? 0}%` }}
                />
            </div>

            <span className="battery-pct">
                {pct === null || pct === undefined ? "-" : `${pct}%`}
            </span>

        </div>

    );

}
